import { useParams } from "react-router-dom";
import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function LandingPage() {
  const { id } = useParams<{ id: string }>();
  const advisorKey = `landing-${id}`;
  const advisor = advisors[advisorKey] || advisors["landing-1"];

  return (
    <AdvisorProvider advisor={advisor}>
      <HomeContent />
    </AdvisorProvider>
  );
}